module.exports = __webpack_public_path__ + "static/media/beeline.8293c5b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/payment/kz_pay/beeline.svg
// module id = 883
// module chunks = 7